require('whatwg-fetch');

function isJSON(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }

    return true;
}

function parseCallback(str) {
    if (!str) {
        return null;
    }

    if (isJSON(str)) {
        return JSON.parse(str);
    }

    let newString = str;
    newString = newString.substring(newString.indexOf('(') + 1);
    newString = newString.substring(0, newString.length - 1);
    return JSON.parse(newString);
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 500) {
        return response;
    }

    const error = new Error(`HTTP request failed ${response.statusText}`);
    error.response = response;
    throw error;
}

module.exports = function request(url, opts, cache = false) {
    const cacheKey = `bbc-notifications-${url}`;

    console.info('Requesting', url);

    if (cache) {
        if (sessionStorage.getItem(cacheKey)) {
            return new Promise((resolve) => {
                resolve(JSON.parse(sessionStorage.getItem(cacheKey)));
            });
        }
    }

    return fetch(url, opts)
        .then(checkStatus)
        .then((response) => {
            if (response.status === 404) {
                return null;
            }

            return response.text();
        })
        .then((text) => {
            const data = parseCallback(text);

            if (cache && data) {
                sessionStorage.setItem(cacheKey, JSON.stringify(data));
            }

            return data;
        })
        .catch((err) => {
            console.error('Request failed', err);
            throw err;
        });
};



/** WEBPACK FOOTER **
 ** ./assets/js/http.js
 **/